import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/tradesy-shipping-essentials';

export default function Example() {
  return (
    <>
      <Head>
        <title>Tradesy Shipping 101: The Essentials to Get You Started</title>
        <meta
          name='description'
          content="Sellers' shipping options, the pros and the cons, and all there is to know about sending items to buyers on Tradesy."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/tradesy-shipping-essentials' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/tradesy-shipping-essentials' />
        <meta property='og:title' content='Tradesy Shipping 101: The Essentials to Get You Started' />
        <meta
          property='og:description'
          content="Sellers' shipping options, the pros and the cons, and all there is to know about sending items to buyers on Tradesy."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Tradesy' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
